import { useMatch } from 'react-router-dom'
import { basePaths } from 'paths'

export default function useIsAdminPage() {
  const isAdminPage = useMatch(`${basePaths.admin_panel}/*`)

  return isAdminPage !== null
}
